const WEEKDAY_ORDER = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
const dayRank = day => {
  const rank = WEEKDAY_ORDER.indexOf(day);
  return rank < 0 ? 7 : rank;
};
const compare = (a, b) => String(a || '').localeCompare(String(b || ''));
const validSchedule = (day, time) => WEEKDAY_ORDER.includes(day) && /^([01]\d|2[0-3]):[0-5]\d$/.test(time || '');

export function settlementLessonTypeLabel(classTypeId, t) {
  const category = String(classTypeId || '').trim().toUpperCase().match(/^([IDTGO])\d+$/);
  return t(`lessonTypes.${category ? category[1] : 'unknown'}`);
}

export function settlementLessonSchedule(lesson) {
  const date = /^\d{4}-\d{2}-\d{2}$/.test(lesson.date || '') ? new Date(`${lesson.date}T12:00:00Z`) : null;
  const actualDayOfWeek = date && !Number.isNaN(date.getTime()) ? ['SUN', ...WEEKDAY_ORDER.slice(0, 6)][date.getUTCDay()] : '';
  const nominalScheduleKnown = validSchedule(lesson.nominalDayOfWeek, lesson.nominalStartTime);
  return { nominalScheduleKnown,
    dayOfWeek: nominalScheduleKnown ? lesson.nominalDayOfWeek : actualDayOfWeek,
    startTime: nominalScheduleKnown ? lesson.nominalStartTime : lesson.startTime || '',
    actualDayOfWeek,
    actualStartTime: lesson.startTime || '',
    moved: nominalScheduleKnown && Boolean((actualDayOfWeek && actualDayOfWeek !== lesson.nominalDayOfWeek) ||
      (lesson.startTime && lesson.startTime !== lesson.nominalStartTime)) };
}

export function groupSettlementLessons(lessons) {
  const groups = new Map();
  lessons.filter(item => item.kind !== 'fixed').forEach(lesson => {
    const key = JSON.stringify([lesson.schoolClassId || lesson.lessonId, lesson.durationMinutes, lesson.classTypeId || '']);
    if (!groups.has(key)) {
      groups.set(key, { key,
        schoolClassId: lesson.schoolClassId || '',
        classTypeId: lesson.classTypeId || '',
        durationMinutes: lesson.durationMinutes,
        lessons: [] });
    }
    groups.get(key).lessons.push(lesson);
  });
  return [...groups.values()].map(group => {
    const ordered = group.lessons.slice().sort((a, b) => compare(a.date, b.date) || compare(a.startTime, b.startTime) || compare(a.lessonId, b.lessonId));
    const currentClass = ordered.find(item => item.classSchedule && validSchedule(item.classSchedule.dayOfWeek, item.classSchedule.startTime));
    const representative = ordered.find(item => validSchedule(item.nominalDayOfWeek, item.nominalStartTime)) || ordered[0];
    const schedule = settlementLessonSchedule(representative);
    const counts = ordered.filter(item => item.rosterKnown === true)
      .map(item => new Set((item.participants || []).filter(student => !student.isGuest && !student.isMakeup).map(student => student.id)).size);
    return { ...group,
      nominalScheduleKnown: schedule.nominalScheduleKnown,
      dayOfWeek: currentClass ? currentClass.classSchedule.dayOfWeek : schedule.dayOfWeek,
      startTime: currentClass ? currentClass.classSchedule.startTime : schedule.startTime,
      lessons: ordered,
      totalLessonsCount: ordered.length,
      payoutEligibleCount: ordered.filter(item => item.payoutEligible).length,
      missingAttendanceCount: ordered.filter(item => item.attendanceState === 'missing').length,
      amountCents: ordered.reduce((sum, item) => sum + (item.amountCents || 0), 0),
      hasUnrecordedAmount: ordered.some(item => item.amountCents === null),
      hasUnknownRoster: counts.length !== ordered.length,
      minParticipants: counts.length ? Math.min(...counts) : null,
      maxParticipants: counts.length ? Math.max(...counts) : null };
  }).sort((a, b) => dayRank(a.dayOfWeek) - dayRank(b.dayOfWeek) || compare(a.startTime, b.startTime) ||
    compare(a.schoolClassId, b.schoolClassId) || compare(a.key, b.key));
}

export function shortParticipantLabel({ label }) {
  const parts = String(label || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length < 2) return parts[0] || '';
  return `${parts[0]} ${Array.from(parts[parts.length - 1])[0]}.`;
}
